import { NewListAction, ShoppingAction, ShoppingActionTypes } from "../actions/shopping.actions";
import { ShoppingItem } from "../models/shopping-item.model";

export interface ShoppingState {
    items: ShoppingItem[];
    notifications: number;
}

export const initialState: ShoppingState = {
    items: [],
    notifications: 0,
};

export function ShoppingReducer(state: ShoppingState = initialState, action: ShoppingAction): ShoppingState {
    switch (action.type) {
        case ShoppingActionTypes.ADD_ITEM:

            const indexMatch = state.items.findIndex(x => x.id == action.payload.id && x.appointmentLocation.toLowerCase() == action.payload.appointmentLocation.toLowerCase());

            if (indexMatch == -1) {
                return {
                    ...state,
                    items: [...state.items, action.payload]
                }
            } else {

                const oldQuantity = state.items[indexMatch].quantity;
                const id = action.payload.id;
                const appointmentType = action.payload.appointmentLocation;

                let newQuantity = oldQuantity + action.payload.quantity;

                if (newQuantity == null || newQuantity == undefined) {
                    newQuantity = 1;
                }

                let newShoppingItem: ShoppingItem = {
                    id: id,
                    quantity: newQuantity,
                    appointmentLocation: appointmentType,
                }

                let newArray = [...state.items];
                newArray.splice(indexMatch,1)

                return {
                    ...state,
                    items: [...newArray, newShoppingItem ]
                }
            }
        case ShoppingActionTypes.REMOVE_ITEM:
            const indexMatchToRemove = state.items.findIndex(x => x.id == action.payload.id && x.appointmentLocation.toLowerCase() == action.payload.appointmentLocation.toLowerCase());
            let newArray = [...state.items];
            newArray.splice(indexMatchToRemove,1)

             return {
                    ...state,
                    items: [...newArray ]
                }
        case ShoppingActionTypes.NEW_LIST:
            return {
                ...state,
                items: [...action.payload]
            }
        case ShoppingActionTypes.UPDATE_QUANTITY:
            const indexMatchToUpdateQty = state.items.findIndex(x => x.id == action.payload.id && x.appointmentLocation.toLowerCase() == action.payload.appointmentLocation.toLowerCase())
            let newArrayForQtyUpdate = [...state.items];
            newArrayForQtyUpdate.splice(indexMatchToUpdateQty, 1);
            return {
                ...state,
                items: [action.payload, ...newArrayForQtyUpdate]
            }
        case ShoppingActionTypes.UPDATE_NOTIFICATIONS:
            return {
                ...state,
                items: [...state.items],
                notifications: action.payload
            }
        default:
            return state;
    }
}